import React, { useEffect } from 'react';
import { useAuth0 } from '../react-auth0-spa';
import { Redirect } from 'react-router-dom';

const SignUp = () => {
  const { loginWithRedirect, loading, isAuthenticated } = useAuth0();

  useEffect(() => {
    if (isAuthenticated === false) {
      loginWithRedirect({ screen_hint: 'signup' });
    }
  }, [isAuthenticated]);

  if (loading) {
    return <div>Loading...</div>;
  }
  if (loading === false && isAuthenticated === true) {
    return <Redirect to="/" />;
  }

  return <p>loading ... </p>;
};

export default SignUp;
